import React from 'react';
import Status from '../../components/mcServerStatus/status.js';
import './status.css';

const StatusPage = () => {
    return (
        <main className="status-page">
            <div className="status-page-inner">
                <h1 className="status-page-title">Minecraft Server Status</h1>
                <p className="status-page-subtitle">Live MOTD and server icon for mc.brogverse.cc</p>
                <Status />
            </div>
        </main>
    );
};

export default StatusPage;